import {
    Alert,
    AlertDescription,
    Flex,
    IconButton,
    Text
} from '@chakra-ui/react';
import { FormEventHandler, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { BackIcon } from '../icons';

interface LayoutProps {
    children?: ReactNode;
    buttons?: ReactNode;
    alert?: string;
    alertSecondary?: string;
    size?: 'normal' | 'large';
    hasBackButton?: boolean;
    isForm?: boolean;
    onSubmit?: FormEventHandler<HTMLFormElement>;
    colorMode: string | undefined;
}

function Layout(props: LayoutProps) {
    const {
        children,
        hasBackButton = false,
        buttons,
        size = 'normal',
        alert,
        alertSecondary,
        isForm,
        onSubmit,
        colorMode,
    } = props;
    const { goBack } = useHistory();

    const innerLaylout = (
        <Flex
            direction="column"
            align="center"
            p={{
                base: '30px 16px 15px',
                sm: '30px 16px 15px',
                md: '60px 40px 40px',
                lg: '68px 16px 40px',
            }}
            mx="auto"
            w="full"
            maxW={size == 'normal' ? '530px' : '800px'}
            minH="800px"
            position="relative"
        >
            {alert && (
                <Flex
                    align="center"
                    justify="center"
                    position="absolute"
                    top="0"
                    left="50%"
                    transform="translateX(-50%)"
                    w="100vw"
                    h="auto"
                >
                    <Alert justifyContent="center" py="6px" bg="red">
                        <AlertDescription>
                            <Text size="xs" color="white">
                                {alert}
                            </Text>
                        </AlertDescription>
                    </Alert>
                </Flex>
            )}
            {alertSecondary && (
                <Flex
                    align="center"
                    justify="center"
                    position="absolute"
                    top="7" //TODO- is this right in all screen formats?
                    left="50%"
                    transform="translateX(-50%)"
                    w="100vw"
                    h="auto"
                >
                    <Alert justifyContent="center" py="6px" bg="orange">
                        <AlertDescription>
                            <Text size="xs" color="white">
                                {alertSecondary}
                            </Text>
                        </AlertDescription>
                    </Alert>
                </Flex>
            )}
            {children}

            {buttons && (
                <Flex
                    align="center"
                    justify="center"
                    position="sticky"
                    bottom="10"
                    left="0"
                    w="full"
                    bgGradient={
                        colorMode == 'light'
                            ? 'linear(to-b, transparent, softGray)'
                            : 'linear(to-b, transparent, navy)'
                    }
                    pt="30px"
                    pb="20px"
                    mt="auto"
                >
                    <Flex
                        direction="column"
                        w="full"
                        maxW="260px"
                        mt="auto"
                        gap="15px"
                    >
                        {buttons}
                    </Flex>
                </Flex>
            )}

            {hasBackButton && (
                <IconButton
                    aria-label="Back"
                    variant="icon"
                    color={colorMode == 'light' ? 'navy' : 'white'}
                    position="absolute"
                    top="40px"
                    left={{ base: '16px', sm: '40px' }}
                    onClick={() => goBack()}
                >
                    <BackIcon />
                </IconButton>
            )}
        </Flex>
    );

    if (isForm) {
        return <form onSubmit={onSubmit}>{innerLaylout}</form>;
    } else {
        return innerLaylout;
    }
}

export default Layout;
